import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import { FaCode } from 'react-icons/fa'
import i18n from '../../../../../../../../lib/i18n';
import config from '../../../../../../../../config';
import { message } from 'antd';
import sign from 'jwt-encode';

function ShareModal({slider={}}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
  }

  const copy = () => {
    var copyText = document.getElementById("question_frame");
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    message.success(i18n('msgFrameViewCopy'))
  }

  return (
    <>
      <FaCode style={{zIndex: 99}} onClick={() => {setIsModalOpen(true)}} />
      <Modal title={i18n('sl_share_frame')} open={isModalOpen} footer={null} onCancel={handleCancel}>
        <textarea rows={4} id="question_frame" style={{width: '100%', border: '1px solid #d9d9d9'}}>
          {`<iframe src="${window.location.origin}/slider/view/${sign({id: slider.id, is_view: true, forse: true}, 'qbm31')}" width="100%" height="570" frameborder="0"></iframe>`}
        </textarea>
        <Button onClick={copy}>{i18n('sl_btn_copy_frame')}</Button>
      </Modal>
    </>
  )
}

export default ShareModal